import { ResponsiveScreenSizes } from "app/utils/const";
import React from "react";
import Media from "react-media";
import { useHistory } from "react-router-dom";
import ManageFundingDesktopHeader from "./components/ManageFundingDesktopHeader/ManageFundingDesktopHeader";
import ManageFundingMobileHeader from "./components/ManageFundingMobileHeader/ManageFundingMobileHeader";
function ManageFundingHeader(
  props: Record<string, any>
): React.ReactElement<
  React.ComponentProps<React$FragmentType>,
  React$FragmentType
> {
  const history = useHistory();
  return (
    <React.Fragment>
      <Media
        query={`(max-width: ${ResponsiveScreenSizes.mobile})`}
        render={() => <ManageFundingMobileHeader history={history} />}
      />
      <Media
        query={`(min-width: ${ResponsiveScreenSizes.desktop})`}
        render={() => <ManageFundingDesktopHeader history={history} />}
      />
    </React.Fragment>
  );
}

export default ManageFundingHeader;
